import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { FaRegFileZipper, FaRepeat } from "react-icons/fa6";
import PrivateApi from "../../services/PrivateApiService";
import { Spinner } from "react-bootstrap";

const DownloadZipItem = ({ zip }) => {
    const API = new PrivateApi(); // API 

    // states used in component
    const [isLoading, setIsLoading] = useState(false); // state for waiting backend for the file
    const [apiError, setApiError] = useState(""); // string error of backend
    const [isClicked, setIsClicked] = useState(false); // state if it's clicked or not
    const [hover, setHover] = useState(false); // state if mouse entered


    // on click download zip
    const downloadZip = (e) => {
        e.preventDefault(); // prevent default behavor of anchor 

        setIsClicked(true);
        setIsLoading(true);

        var file_name = zip.split("/").pop(); // downloads file name
        var path = String(zip).replaceAll('/', '&'); // will be sent to api absolute path

        // if error reset error
        if (apiError !== "") {
            setApiError("");
        }

        // send call to backend
        API.post_InvoiceDownloadZip(path)
            .then(res => {
                setIsLoading(false);
                const url = window.URL.createObjectURL(new Blob([res.data])); // Create a Blob from the response data
                const link = document.createElement('a'); // Create a temporary anchor element
                link.href = url;

                // Set the downloaded file name 
                const fileName = file_name;

                link.setAttribute('download', fileName); // Specify file name
                document.body.appendChild(link); // Append the link to the body
                link.click(); // Trigger the download
                document.body.removeChild(link); // Clean up the link element
                window.URL.revokeObjectURL(url); // Revoke the object URL
            })
            .catch(err => {
                setIsLoading(false);
                setApiError("Es ist ein unbekannter Fehler aufgetreten.");
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                }
            });
    }

    return (
        <li key={zip.split("/").pop()}>
            {apiError === ""?
                isLoading?
                    <><Spinner animation="border"/> downloading...</>:
                    <a 
                        href="#" 
                        className="link-energo" 
                        onClick={e => downloadZip(e)}
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                    >
                        {isClicked?
                            hover ?
                                <><FaRepeat size={20} /> {zip.split("/").pop()}</>
                                :
                                <><FaCheck size={20} /> {zip.split("/").pop()}</>
                            :
                            <><FaRegFileZipper size={30} /> {zip.split("/").pop()}</>
                        }
                    </a>
            :
                <p className="text-danger">{apiError}  <a href="#" onClick={e => downloadZip(e)} className="link-energo">Nochmal versuchen</a></p>
            }
        </li>
    )
}
export default DownloadZipItem;